import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';

import { ImportedRow } from '../../convert-excel-to-impact-answers';
import { mapToLabel, mapToSector } from './shared-mapper';

export function buildBaseAnswer(
  row: ImportedRow,
  category: Category,
): ImpactCo2Answer<ValuesImport> {
  const sector = mapToSector(row);
  const label = mapToLabel(row);
  return {
    id: 0,
    userId: '',
    sector: sector,
    category: category,
    isExternal: false,
    source: '',
    values: {
      label: label,
      tags: [],
      score: 0,
    },
  };
}

export type ValuesImport = {
  label?: string;
  tags: Array<{ id: number; name: string }>;
  score: number;
};
